<!--  -->
<template>
  <div class="roadmap" ref="roadmap">
    <!-- <header>
      <span class="back" @click='back()'></span>
      <span>我的路线</span>
      <span class="more"></span>
    </header> -->
    <div class="content_map">
      <img src="../assets/images/images/wodexianlu-xiangqing.png" alt="" />

      <div class="box">
        <div class="map">
          <div id="container" ref='container'>

          </div>
        </div>
        <div class="head">
          <div class="img">
            <img v-if="roaddetail.userHeadImage!=''" :src="roaddetail.userHeadImage" />
            <img v-else src="../assets/images/head.png" />
          </div>
          <div class="detail">
            <h3>{{roaddetail.userName}}</h3>
          </div>
          <div class="time">{{roaddetail.tourTime}}</div>
        </div>
        <div class="content">
          <h3><span v-for="(item,index) in capitals" :key='index'>{{item.content}}<i>———</i></span></h3>
          <p>{{roaddetail.theme}}</p>
          <p>{{roaddetail.description}}</p>
          <div class="bot" v-if="!otherfare">
            <dd class="vote1" @click="vote()" v-if="!voted"><span>{{roaddetail.voteNum}}</span></dd>
            <dd class="vote1 voted" v-else-if="voted"><span>{{roaddetail.voteNum}}</span></dd>
            <dd class="fare1" @click="share()"><span>转发</span></dd>
          </div>
          <div class="bot" v-if="otherfare">
            <dd class="vote1" @click="sharevote()"><span>{{roaddetail.voteNum}}</span></dd>
            <dd class="fare1" @click="toapp()"><span>转发</span></dd>
          </div>

        </div>
      </div>

    </div>
    <div class="layer" ref="layer" v-show="layer">
      <img :src="imgUrl" alt="">
    </div>
    <div class="shadow" v-show="layer" @click="hidelayer()"></div>
    <div id="panel"></div>

    <el-dialog :visible.sync="logDialog" width="70%" title="" :show-close="false">
      <el-row>
        <p>请先登录</p>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="logDialog = false">取 消</el-button>
        <el-button size="small" type="danger" @click="login">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<style>
.voted{ opacity: .7;}
#panel {
  display: none;
}
.layer {
  position: fixed;
  text-align: center;
  top: 50%;
  margin-top: -160px;
  z-index: 99;
}
.layer img {
  width: 90%;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgb(0, 0, 0, 0.2);
}
</style>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from "../conf/api";
import "../assets/css.css";
import AMap from "AMap";
let Amap, marker;
import html2canvas from "html2canvas";
import VueAMap from "vue-amap";

let amapManager = new VueAMap.AMapManager();

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "roadmap",
  components: {},
  data() {
    //这里存放数据
    return {
      amapManager,
      voted: false,
      layer: false,
      logDialog: false,
      token: "",
      userid: "",
      userimg: "",
      username: "",
      roadlist: [],
      roaddetail: "",
      tourid: "",
      capitals: [],
      imgUrl: "",
      otherfare: false,
      voteSingleNum: 0,
      theme: "",
      currentPage: 0,
      pageSize: 10,
      mine: "", //我的
    };
  },
  async mounted() {
    //

    let params = this.$route.query;
    this.token = params.token;
    this.tourid = params.tourid;
    this.theme = params.theme;
    this.mine = params.mine;
    // if (params.currentPage > 0) {
    //   params.currentPage = params.currentPage - 1;
    // }
    this.currentPage = params.currentPage;
    if (!params.token) {
      this.otherfare = true;
    }
    console.log(params);
    if (this.token) {
      await this.axios
        .get("https://www.ccmapp.cn/middleware/userextrainfo", {
          // .get("https://testapi.ccmapp.cn:15400/middleware/userextrainfo", {
          params: {
            token: this.token,
          },
        })
        .then((res) => {
          this.username = res.data.data.user.realname;
          this.userimg = res.data.data.user.photo;
          this.userid = res.data.data.user._id;
        });
    }

    this.getTour(0);
    //this.getlocation();
    //this.initmap();
  },

  methods: {
    login() {
      this.$router.push({
        path: "/login",
        query: {
          platform: this.$route.query.platform,
        },
      });
    },
    initmap() {
      console.log(this.roaddetail, "routes");
      this.roaddetail.tourRoutes.map((res) => {
        if (res.longitude) {
          this.capitals.push({
            center: [res.longitude, res.latitude],
            content: res.name,
          });
        }
      });
      let capitals = this.capitals;
      let start = capitals[0].center;
      let end = capitals[capitals.length - 1].center;
      let center = capitals.slice(1, capitals.length - 1);
      center.map((res, i, arr) => {
        arr[i] = new AMap.LngLat(res.center[0], res.center[1]);
      });
      console.log(capitals, center, "123");
      //基本地图加载
      var map = new AMap.Map("container", {
        resizeEnable: true,
        center: [116.397428, 39.90923], //地图中心点
        zoom: 13, //地图显示的缩放级别
      });
      //构造路线导航类
      var driving = new AMap.Driving({
        map: map,
        panel: "panel",
      });
      // 加点儿

      for (let i = 0; i < capitals.length; i++) {
        console.log("capitals");
        marker = new AMap.Marker({
          position: capitals[i].center, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        });
        marker.setLabel({
          offset: new AMap.Pixel(10, 10), // 设置文本标注偏移量
          content: capitals[i].content, // 设置文本标注内容
          direction: "right", // 设置文本标注方位
        });
        marker.setMap(map);
      }
      // 根据起终点经纬度规划驾车导航路线
      driving.search(
        new AMap.LngLat(start[0], start[1]),
        new AMap.LngLat(end[0], end[1]),
        {
          waypoints: center,
        },
        function (status, result) {
          // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
          if (status === "complete") {
            console.log("绘制驾车路线完成");
          } else {
            console.log("获取驾车数据失败：" + result);
          }
        }
      );
    },
    hidelayer() {
      this.layer = false;
    },
    toapp() {
      if(this.$route.query.needLog == "log") {
        this.logDialog = true;
        return false;
      }
      var u = navigator.userAgent;
      if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
        //ios
        window.location.href =
          "https://itunes.apple.com/cn/app/%E6%96%87%E6%97%85/id1398114250?mt=8";
      } else if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
        //android
        window.location.href =
          "https://sj.qq.com/myapp/detail.htm?apkName=com.ccmapp.news";
      }
    },
    share() {
      if(this.$route.query.needLog == "log") {
        this.logDialog = true;
        return false;
      }
      this.axios
        .get(API_1 + Global.share, {
          params: { userID: this.userid, tourID: this.tourid },
        })
        .then((res) => {
          console.log(res, "share");
          if (res.data.code == 200) {
            let title = "";
            this.roaddetail.tourRoutes.map((i, index) => {
              if (this.roaddetail.tourRoutes.length - 1 == index) {
                title += i.name;
              } else {
                title += i.name + "-";
              }
            });
            window.location.href =
              "/roadmap?option=share&shareDescription=" +
              this.roaddetail.description +
              "&shareImage=https://testapi.ccmapp.cn/apis/file/dl/source/5f7157b3c182cd5ca4ab5e22.png&shareTitle=" +
              title +
              "&shareUrl=https://apps.ccmapp.cn/dist/jump.html?tourid=" +
              this.roaddetail.id +
              "&currentPage=" +
              this.currentPage +
              "$theme=" +
              this.theme;
          }
        });
    },
    vote() {
      if(this.$route.query.needLog == "log") {
        this.logDialog = true;
        return false;
      }
      this.axios
        .get(API_1 + Global.vote, {
          params: { id: this.tourid, userID: this.userid },
        })
        .then((res) => {
          console.log(res, "vote");
          if (res.data.code == 200) {
            this.voted = true;
          }
          this.getTour(1);
        });
    },
    sharevote() {
      if(this.$route.query.needLog == "log") {
        this.logDialog = true;
        return false;
      }
      this.axios
        .get(API_1 + Global.shareVote, {
          params: { tourID: this.tourid, userID: this.userid },
        })
        .then((res) => {
          console.log(res);
          this.getTour(1);
        });
    },
    saveimg() {
      html2canvas(this.$refs.container, {
        useCORS: true,
        x: 50,
        y: 240,
      }).then((canvas) => {
        let dataURL = canvas.toDataURL("image/png");
        this.imgUrl = dataURL;
        console.log(this.imgUrl);
        this.layer = true;
        this.$message("请长按保存!");
      });
    },
    add() {
      console.log(this.roaddetail, "routes");
      this.roaddetail.tourRoutes.map((res) => {
        if (res.longitude) {
          this.capitals.push({
            center: [res.longitude, res.latitude],
            content: res.name,
          });
        }
      });
      let capitals = this.capitals;
      console.log(this.roaddetail.tourRoutes, capitals, "123");

      // 创建一个 Marker 实例：
      for (let i = 0; i < capitals.length; i++) {
        marker = new AMap.Marker({
          position: capitals[i].center, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        });
        marker.setLabel({
          offset: new AMap.Pixel(10, 10), // 设置文本标注偏移量
          content: capitals[i].content, // 设置文本标注内容
          direction: "right", // 设置文本标注方位
        });
        marker.setMap(Amap);
      }

      let lineArr = new Array();
      capitals.map((val) => {
        lineArr.push(val.center);
      });
      //     }) lineArr.push(new AMap.LngLat(116.420087, 39.908374)); //第二个点
      // lineArr.push(new AMap.LngLat(116.432303, 39.909320)); //第三个点
      // lineArr.push(new AMap.LngLat(116.434679, 39.908769)); //第四个点
      // lineArr.push(new AMap.LngLat(116.434335, 39.924568)); //第五个点

      //绘制轨迹
      let polyline = new AMap.Polyline({
        // eslint-disable-line no-unused-vars
        path: lineArr,
        showDir: true,
        dirColor: "pink",
        strokeColor: "#FDAC41", // 线颜色
        strokeWeight: 4,
      });
      Amap.add(polyline);
      Amap.setFitView();
    },
    getlocation() {
      Amap = new AMap.Map("container", {
        // eslint-disable-line no-unused-vars
        zoom: 11, //级别
        center: [116.397428, 39.90923], //中心点坐标
        mapStyle: "amap://styles/fresh",
        resizeEnable: true, //使用3D视图
      });
      AMap.plugin(["AMap.Autocomplete", "AMap.PlaceSearch"], function () {
        let autoOptions = {
          input: "keyword",
          citylimit: true, // 使用联想输入的input的id
        };
        let autocomplete = new AMap.Autocomplete(autoOptions);
        // let placeSearch = new AMap.PlaceSearch({
        //     city: '北京',
        //     citylimit: true,
        //     autoFitView: false,
        //     map: Amap
        // })
        AMap.event.addListener(autocomplete, "select", function (e) {
          if (this.addmarker) {
            this.addmarker.setMap(null);
            this.addmarker = null;
          }
          this.addmarker = new AMap.Marker({
            position: [e.poi.location.lng, e.poi.location.lat],
            icon: require("../assets/images/icon_dian.png"),
          });
          console.log(e);
          let detailedAddress = e.poi.district + e.poi.address + e.poi.name;
          console.log(detailedAddress);
          this.addmarker.setLabel({
            offset: new AMap.Pixel(20, 20), // 设置文本标注偏移量
            content: `<div class = 'area'>${e.poi.name}</div>`, // 设置文本标注内容
            direction: "right",
          });

          Amap.setCenter([e.poi.location.lng, e.poi.location.lat]); // 设置地图中心点
          Amap.add(this.addmarker);
        });

        // 通过点击按钮搜索 此功能暂时关闭 有需要开启
        // AMap.event.addDomListener(btn, "click", function(e) {
        //   console.log(autocomplete)
        //   placeSearch.search(autocomplete.d_);
        // });
        //   placeSearch.search(autocomplete, function (status, result) {
        //  // 查询成功时，result即对应匹配的POI信息
        //     console.log(result)
        //   })
        // placeSearch.search(e.poi.name)
        // placeSearch.search(e.poi.name)
      });
    },
    getTour(n) {
      this.axios
        .get(API_1 + Global.getTour, {
          params: {
            id: this.tourid,
            searchUserID: this.userid,
          },
        })
        .then((res) => {
          this.roaddetail = res.data.data;
          console.log(res, this.roaddetail, "roaddetail");
          if (res.data.data.isVote == 1) {
            this.voted = true;
          }
          if (n == 0) {
            this.initmap();
          }
        });
    },

    back() {
      this.$router.go(-1);
    },
  },
};
</script>
 <style>
 .box{ margin: 25px 10px 0 10px; background:url(../assets/images/images/border-mid.png) scroll 0 20px repeat-y #fff; background-size: contain; 
 position: relative; padding: 0 10px;}
.box:before{ position: absolute; display: block; content: ""; height: 14px; width: 100%; top: -14px; left: 0; background:url(../assets/images/images/border-top.png) top no-repeat #fff; background-size: 100% 14px; border-radius: 5px 5px 0 0;}
.box:after{ position: absolute; display: block; content: ""; height: 15px; width: 100%; bottom: -15px; left: 0; background:url(../assets/images/images/border-bottom.png) top no-repeat #fff; background-size: contain; border-radius: 0 0 5px 5px;}
#container {
  height: 356px;
}
.roadmap .box .head{ padding-top: 10px; display: flex; padding: 10px 10px 0 10px; }
.box .head > div.img{  overflow: hidden;}
.box .head > div.detail h3{ padding-left: 15px; font-size: 16px; font-weight: bold; padding-top: 10px;}
.box .head > div.time{ flex: 2; text-align: right; font-size: 16px; color: #999; padding-top: 10px;}
.box .head > div.img img{ width: 67px; height: 67px; border-radius: 50%;}
.content{ text-align: left; margin-top: 20px; padding: 0 10px;}
.content h3{ font-size: 16px;  padding-bottom: 10px; line-height: 24px;}
.content h3 span{ font-weight: bold;}
.content h3 span:last-child i{ display: none;}
.content p{ font-size: 16px; color: #999; padding-bottom: 5px;}
.bot{ display: flex; padding: 15px 0;}
.bot .vote1{ padding-left: 25px; line-height: 25px;  flex: 1; background:url(../assets/images/images/zan-icon.svg) no-repeat; background-size: 22px; font-size: 16px;}
.bot .fare1{ flex: 1; background:url(../assets/images/images/fenxiang-icon.svg) right no-repeat; background-size: 22px; font-size: 0;}

.content_map {
  background-size: 100% auto;
  margin-bottom: 25px;
}
.map_box {
  background: url(../assets/images/bg_map2.png) no-repeat;
  background-size: 100% 100%;
}
.map_box > h2 {
  padding: 20px 0 20px 0;
  text-align: center;
}
.map_box > h2 img {
  width: 66px;
}
.map_box .head {
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.map_box .head .img {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background: #bbb;
}
.map_box .map {
  margin: 13px 22px;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 0px 2px 0px rgba(167, 182, 212, 0.4);
}
.map_box .map #container {
  height: 270px;
}
.map_box .head .img img {
  width: 33px;
  height: 33px;
  border-radius: 50%;
}
.map_box .head .detail {
  width: 60%;
  text-align: left;
  padding-left: 10px;
}
.map_box .head .detail h3 {
  font-size: 14px;
  color: #0a65e7;
}
.map_box .head .detail p {
  font-size: 10px;
  color: #6798ff;
  margin-right: 10px;
  overflow: hidden;
}
.map_box .head .time {
  font-size: 10px;
  color: #6798ff;
}
.map_box .map dd {
  text-align: center;
  font-size: 11px;
  color: #fdac41;
  margin-top: 10px;
}
.map_box .map dd span {
  font-size: 14px;
}
.buttton {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 69px;
}
.buttton dd img {
  width: 160px;
}
/* .amap-icon {
  width: 14px !important;
  height: 14px !important;
  background: #0a65e7;
  border-radius: 50%;
  border: 4px solid #fff;
} */
.amap-marker-label {
  padding: 5px 10px !important;
  border: 0 !important;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3) !important;
}
.amap-marker-label {
  border-radius: 10px;
}
</style>
